import React, { useState, useEffect } from "react";
import {
    withGoogleMap,
    withScriptjs,
    GoogleMap,
    Marker,
    InfoWindow,
    GroundOverlay,
} from "react-google-maps";

function Map({ lat, lng, hotelName }) {
    return (
        <GoogleMap
            defaultZoom={15}
            // 22.989418792643086, 72.58871934179528
            defaultCenter={{ lat: lat, lng: lng }}
        >
            <Marker
                // key={park.properties.PARK_ID}

                defaultOptions={{}}
                // 28.664969709277386, 76.89000879658718
                position={{
                    lat: lat,
                    lng: lng,
                }}
                icon={{
                    url: "data:image/svg+xml;charset=UTF-8;base64,PHN2ZyB3aWR0aD0iNTIiIGhlaWdodD0iNjIiIHZpZXdCb3g9IjAgMCA1MiA2MiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KICAgIDxwYXRoIGQ9Ik0yNi4zMiAzQzEyLjkxIDMgMiAxMi45NzUgMiAyNS4yMzRjMCAxMy40NTMgMTYuOTA4IDI4Ljc1MiAyMi4wOTYgMzMuMTIyYTMuNDQ3IDMuNDQ3IDAgMCAwIDQuNDUgMGM1LjE4Ni00LjM3MiAyMi4wOTQtMTkuNjc0IDIyLjA5NC0zMy4xMjJDNTAuNjQgMTIuOTc0IDM5LjczIDMgMjYuMzIgM3oiIGZpbGw9IiMxOTU4QjYiLz4KICAgIDxwYXRoIGQ9Ik0yOS4yMTUgMTguMjEzaDMuNDc0Yy45NiAwIDEuNzM3Ljc4NiAxLjczNyAxLjc1NSAwIC45Ny0uNzc4IDEuNzU2LTEuNzM3IDEuNzU2aC0zLjQ3NGMtLjk2IDAtMS43MzgtLjc4Ni0xLjczOC0xLjc1NnMuNzc4LTEuNzU1IDEuNzM4LTEuNzU1eiIgZmlsbD0iI2ZmZiIvPgogICAgPHBhdGggZD0iTTQwLjIxNiAzNC4wMWMwIC45Ny0uNzc4IDEuNzU2LTEuNzM3IDEuNzU2LS45NiAwLTEuNzM3LS43ODYtMS43MzctMS43NTZ2LTEuNzU1YzAtLjY0Ni0uNTE5LTEuMTctMS4xNTgtMS4xN2gtMTguNTNjLS42NCAwLTEuMTU4LjUyNC0xLjE1OCAxLjE3djEuNzU1YzAgLjk3LS43NzggMS43NTYtMS43MzcgMS43NTYtLjk2IDAtMS43MzctLjc4Ni0xLjczNy0xLjc1NnYtNi40MzZjMC0xLjkzOSAxLjU1NS0zLjUxIDMuNDc0LTMuNTFoMTkuNjg4Yy42NCAwIDEuMTU4LS41MjQgMS4xNTgtMS4xN3YtNS4yNjdjMC0uOTY5Ljc3Ny0xLjc1NSAxLjczNy0xLjc1NS45NiAwIDEuNzM3Ljc4NiAxLjczNyAxLjc1NVYzNC4wMXoiIGZpbGw9IiNmZmYiLz4KPC9zdmc+",
                    scaledSize: new window.google.maps.Size(30, 30),
                    origin: new window.google.maps.Point(0, 0),
                    anchor: new window.google.maps.Point(0, 0),
                }}
            />
            <InfoWindow
                position={{
                    lat: lat,
                    lng: lng,
                }}
            >
                <div className="map-info">{hotelName}</div>
            </InfoWindow>
        </GoogleMap>
    );
}

const MapWrapped = withGoogleMap(Map);

export default function Maps(props) {
    let latLon = props.latlong !== undefined && props.latlong.split("|");

    let latitudes = parseFloat(latLon[0]);
    let longitudes = parseFloat(latLon[1]);

    return (
        <div style={{ width: "100%", height: "100%" }}>
            <MapWrapped
                googleMapURL={
                    "https://maps.googleapis.com/maps/api/js?key=AIzaSyAeCDbEPFYP5aVlxPzE8ZDE2O3I_pelYOM&v=3.exp&libraries=places"
                }
                loadingElement={<div style={{ height: `100%` }} />}
                containerElement={<div style={{ height: `100%` }} />}
                mapElement={<div style={{ height: `100%` }} />}
                lat={latitudes}
                lng={longitudes}
                hotelName={props.hotelName}
            />
        </div>
    );
}
